import { CruisesContract as API, definitions } from '@luxuryescapes/contract-svc-cruise';

import cruisesAPI from './CruisesApiService';

const resource = 'rate-groups';

export type RateGroupRule = definitions['RATE_GROUP_RULE'];
export type RateGroupRuleParams = definitions['GET_RATE_GROUP_RULES_QUERY'];
export type CreateRateGroupRuleBody = definitions['CREATE_RATE_GROUP_RULE_BODY'];
export type UpdateRateGroupRuleBody = definitions['UPDATE_RATE_GROUP_RULE_BY_ID_BODY'];

const list = async (params: RateGroupRuleParams): Promise<API.Response<Array<RateGroupRule>>> => {
  return await cruisesAPI.http.get({ resource: `${resource}/rules`, queryString: JSON.stringify(params) });
};

const create = async (rateGroupId: string, body: CreateRateGroupRuleBody): Promise<RateGroupRule> => {
  const response = await cruisesAPI.http.post<API.Response<RateGroupRule>>({
    resource: `${resource}/${rateGroupId}/rules`,
    body,
  });

  return response.result;
};

const update = async (rateGroupId: string, id: string, body: UpdateRateGroupRuleBody): Promise<RateGroupRule> => {
  const response = await cruisesAPI.http.put<RateGroupRule>({
    resource: `${resource}/${rateGroupId}/rules/${id}`,
    body,
  });

  return response.result;
};

const deleteById = async (rateGroupId: string, id: string): Promise<void> => {
  await cruisesAPI.http.delete({ resource: `${resource}/${rateGroupId}/rules/${id}` });
};

export default {
  list,
  create,
  update,
  deleteById,
};
